<div class="row align-items-center mt-3" *ngIf="pagingInfo">
    <div class="col-md"></div>
    <div class="col-md-auto mt-md-0"
        *ngIf="pagingInfo.listCnt > 0">
        <div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-sm btn-outline-secondary"
                *ngIf="pagingInfo.startPage > 1"
                (click)="clickPageNumber(pagingInfo.curPage-pagingInfo.rangeSize)">
                <span aria-hidden="true">
                    prev {{pagingInfo.rangeSize}}
                </span>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary"
                *ngIf="pagingInfo.startPage > pagingInfo.rangeSize"
                (click)="clickPageNumber(1)">
                <span aria-hidden="true">
                    1
                </span>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary disabled"
                *ngIf="pagingInfo.startPage > pagingInfo.rangeSize">
                <span aria-hidden="true">
                    ...
                </span>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary"
                *ngFor="let pageNumber of pagingInfo.listPageNumber"
                [ngClass]="{'active':pageNumber === pagingInfo.curPage}"
                (click)="clickPageNumber(pageNumber)">
                <span aria-hidden="true">
                    {{pageNumber}}
                </span>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary disabled"
                *ngIf="pagingInfo.endPage < pagingInfo.pageCnt">
                <span aria-hidden="true">
                    ...
                </span>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary"
                *ngIf="pagingInfo.endPage < pagingInfo.pageCnt"
                (click)="clickPageNumber(pagingInfo.pageCnt)">
                <span aria-hidden="true">
                    {{pagingInfo.pageCnt}}
                </span>
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary"
                *ngIf="pagingInfo.curRange < pagingInfo.rangeCnt"
                (click)="clickPageNumber(pagingInfo.endPage+1)">
                <span aria-hidden="true">
                    next {{pagingInfo.rangeSize}}
                </span>
            </button>
        </div>




        <!-- <nav>
            <ul class="pagination pagination-sm pagination-fill mb-0">
                <li class="page-item" *ngIf="pagingInfo.startPage > 1">
                    <a class="page-link"
                        [routerLink]=""
                        (click)="clickPageNumber(pagingInfo.curPage-pagingInfo.rangeSize)">
                        <span aria-hidden="true">
                            prev {{pagingInfo.rangeSize}}
                        </span>
                    </a>
                </li>
                <li class="page-item" *ngIf="pagingInfo.startPage > pagingInfo.rangeSize">
                    <a class="page-link"
                        [routerLink]=""
                        (click)="clickPageNumber(1)">
                        1
                    </a>
                </li>
                <li class="page-item disabled" *ngIf="pagingInfo.startPage > pagingInfo.rangeSize">
                    <a class="page-link"
                        [routerLink]="">
                        ...
                    </a>
                </li>
                <li class="page-item"
                    *ngFor="let pageNumber of pagingInfo.listPageNumber"
                    [ngClass]="{'active':pageNumber === pagingInfo.curPage}">
                    <a class="page-link"
                        [routerLink]=""
                        (click)="clickPageNumber(pageNumber)">
                        {{pageNumber}}
                    </a>
                </li>
                <li class="page-item disabled" *ngIf="pagingInfo.endPage < pagingInfo.pageCnt">
                    <a class="page-link"
                        [routerLink]="">
                        ...
                    </a>
                </li>
                <li class="page-item" *ngIf="pagingInfo.endPage < pagingInfo.pageCnt">
                    <a class="page-link"
                        [routerLink]=""
                        (click)="clickPageNumber(pagingInfo.pageCnt)">
                        <span aria-hidden="true">
                            {{pagingInfo.pageCnt}}
                        </span>
                    </a>
                </li>
                <li class="page-item" *ngIf="pagingInfo.curRange < pagingInfo.rangeCnt">
                    <a class="page-link"
                        [routerLink]=""
                        (click)="clickPageNumber(pagingInfo.endPage+1)">
                        <span aria-hidden="true">
                            next {{pagingInfo.rangeSize}}
                        </span>
                    </a>
                </li>
            </ul>
        </nav> -->
    </div>

    <div class="col-md mt-md-0">
        <div class="d-flex justify-content-end align-items-center">
            <span>
                전체 {{pagingInfo.listCnt}}개
            </span>
            <!-- <div *ngIf="pagingInfo.listCnt > 0"
                class="ml-2">
                <select class="form-control form-control-sm"
                    [(ngModel)]="pagingInfo.pageSize"
                    (ngModelChange)="changeCountRowPerPage($event)">
                    <option *ngFor="let countRow of listCountRowPerPage;"
                        [value]="countRow">{{countRow}} 개씩</option>
                </select>
            </div> -->
        </div>
    </div>
</div>
